import { useNavigate } from "react-router";
import { ChevronDownIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";
import { jobsStore } from "@/stores";
import { JobStatus } from "@/types";

export const JobPipelineJobsDropdown = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const navigate = useNavigate();

  const jobs = jobsStore((state) => state.jobs);
  const activeJobs = jobs.filter(({ job }) => job.status === JobStatus.ACTIVE);
  // We could find ourselves in a situation where the current job is not active
  // if the user manually navigates to the pipeline page of such a job.
  const currentJob = activeJobs.find(({ job }) => job.id === currentJobId)?.job;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          className="rounded-full font-medium text-slate-700"
          variant="outlineSecondary"
        >
          {currentJob?.title ?? "Select a job"}
          <ChevronDownIcon className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>Select job</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {activeJobs.map(({ job }) => (
          <DropdownMenuCheckboxItem
            checked={job.id === currentJobId}
            key={job.id}
            onClick={() => {
              void navigate(
                `/companies/${currentCompanyId}/jobs/${job.id}/pipeline`,
              );
            }}
          >
            {job.title}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
